import React from 'react';
import { ROOM_TYPES, type RoomType } from '@/lighting-app/data/lightingStandards';

interface Props {
  selected: RoomType | null;
  onSelect: (room: RoomType) => void;
}

export default function InspectStepRoom({ selected, onSelect }: Props) {
  return (
    <div className="slide-up">
      <div className="text-center mb-8">
        <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
          ما نوع المكان الذي تريد فحص إضاءته؟
        </h2>
        <p className="text-muted-foreground">سنقارن الإضاءة الحالية بالمعايير الموصى بها لهذا النوع</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {ROOM_TYPES.map((room) => (
          <button
            key={`inspect-room-${room.id}`}
            onClick={() => onSelect(room)}
            className={`room-grid-item p-4 rounded-2xl border-2 text-center transition-all duration-200 cursor-pointer ${
              selected?.id === room.id
                ? 'border-secondary bg-gray-50 shadow-md'
                : 'border-border bg-card hover:border-secondary/40 hover:bg-gray-50'
            }`}
          >
            <div className="text-3xl mb-3">{room.icon}</div>
            <div className="font-bold text-foreground text-sm mb-1">{room.nameAr}</div>
            <div className="text-xs text-muted-foreground font-tabular">
              موصى به: {room.recommendedLux} Lux
            </div>
          </button>
        ))}
      </div>

      {selected && (
        <div className="mt-6 p-4 bg-gray-50 rounded-xl border border-secondary/20 fade-in">
          <div className="flex items-center gap-3">
            <span className="text-2xl">{selected.icon}</span>
            <div>
              <div className="font-bold text-foreground">{selected.nameAr}</div>
              <div className="text-sm text-muted-foreground">{selected.description}</div>
            </div>
            <div className="mr-auto text-right">
              <div className="text-xs text-muted-foreground">نطاق الإضاءة</div>
              <div className="font-bold text-secondary font-tabular">
                {selected.minLux} – {selected.maxLux} Lux
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}